export default {
    positionOptions: [
        {
            code: 'pos-left-top',
            icon: 'pos-left-top',
            cssAnimation: 'animationFadeInLeft',
            cssAnimationName: 'engage--fadeInLeft',
            row: 'top',
            col: 'left',
            defaultStyle: {
                left: '12px',
                top: '12px',
                bottom: 'initial',
                right: 'initial',
                position: 'fixed',
                transform: 'translate(0, 0)'
            }
        },
        {
            code: 'pos-center-top',
            icon: 'pos-center',
            cssAnimation: 'animationFadeIn',
            cssAnimationName: 'engage--fadeIn',
            row: 'top',
            col: 'center',
            defaultStyle: {
                left: '50%',
                top: '12px',
                bottom: 'initial',
                right: 'initial',
                transform: 'translate(-50%, 0)',
                position: 'fixed'
            }
        },
        {
            code: 'pos-right-top',
            icon: 'pos-right-bottom',
            cssAnimation: 'animationFadeInRight',
            cssAnimationName: 'engage--fadeInRight',
            row: 'top',
            col: 'right',
            defaultStyle: {
                left: 'initial',
                top: '12px',
                bottom: 'initial',
                right: '12px',
                transform: 'translate(0, 0)',
                position: 'fixed'
            }
        },
        {
            code: 'pos-left-center',
            icon: 'pos-left-center',
            cssAnimation: 'animationFadeInLeft',
            cssAnimationName: 'engage--fadeInLeft',
            row: 'center',
            col: 'left',
            defaultStyle: {
                left: '12px',
                top: '50%',
                bottom: 'initial',
                right: 'initial',
                position: 'fixed',
                transform: 'translate(0, -50%)'
            }
        },

        {
            code: 'pos-center',
            icon: 'pos-center',
            cssAnimation: 'animationFadeIn',
            row: 'center',
            col: 'center',
            cssAnimationName: 'engage--fadeIn',
            default: true,
            defaultStyle: {
                left: '50%',
                top: '50%',
                bottom: 'initial',
                right: 'initial',
                transform: 'translate(-50%, -50%)',
                position: 'fixed'
            }
        },
        {
            code: 'pos-right-center',
            icon: 'pos-right-bottom',
            cssAnimation: 'animationFadeInRight',
            cssAnimationName: 'engage--fadeInRight',
            row: 'center',
            col: 'right',
            defaultStyle: {
                left: 'initial',
                top: '50%',
                bottom: 'initial',
                right: '12px',
                transform: 'translate(0, -50%)',
                position: 'fixed'
            }
        },
        {
            code: 'pos-left-bottom',
            icon: 'pos-left-bottom',
            cssAnimation: 'animationFadeInLeft',
            cssAnimationName: 'engage--fadeInLeft',
            row: 'bottom',
            col: 'left',
            defaultStyle: {
                left: '12px',
                top: 'initial',
                bottom: '12px',
                right: 'initial',
                position: 'fixed',
                transform: 'translate(0, 0)'
            }
        },

        {
            code: 'pos-center-bottom',
            icon: 'pos-center',
            row: 'bottom',
            col: 'center',
            cssAnimation: 'animationFadeIn',
            cssAnimationName: 'engage--fadeIn',
            defaultStyle: {
                left: '50%',
                top: 'initial',
                bottom: '12px',
                right: 'initial',
                transform: 'translate(-50%, 0)',
                position: 'fixed',
                margin: 'auto'
            }
        },

        {
            code: 'pos-right-bottom',
            icon: 'pos-right-bottom',
            cssAnimation: 'animationFadeInRight',
            cssAnimationName: 'engage--fadeInRight',
            row: 'bottom',
            col: 'right',
            defaultStyle: {
                left: 'initial',
                top: 'initial',
                bottom: '12px',
                right: '12px',
                transform: 'translate(0, 0)',
                position: 'fixed',
                margin: 'auto'
            }
        }
    ],
    stickyPosOptions: [
        {
            code: 'pos-sticky-top',
            row: 'top',
            col: 'center',
            defaultStyle: {
                left: '50%',
                top: '0',
                bottom: 'auto',
                right: 'auto',
                transform: 'translate(-50%, 0)',
                position: 'fixed'
            }
        },
        {
            code: 'pos-sticky-bottom',
            row: 'bottom',
            col: 'center',
            cssAnimation: 'animationFadeIn',
            cssAnimationName: 'engage--fadeIn',
            defaultStyle: {
                left: '50%',
                top: 'auto',
                bottom: '0',
                right: 'initial',
                transform: 'translate(-50%, 0)',
                position: 'fixed',
                margin: 'auto'
            }
        }
    ],
    closeBtnStyleOptions: [
        {
            code: 'styleA',
            icon: 'close2',

            style: `
                width: 100%;
                height: 100%;
                background-color: #ffffff;
                border-radius: 50%;
            `,
            svg: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" xml:space="preserve" style="width: 100%"><rect style="fill:none;" width="16" height="16"/><path d="M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7c3.9,0,7-3.1,7-7C15,4.1,11.9,1,8,1z M10.8,10c0.2,0.2,0.2,0.6,0,0.8s-0.6,0.2-0.8,0 l-2-2l-2,2c-0.2,0.2-0.6,0.2-0.8,0s-0.2-0.6,0-0.8l2-2l-2-2c-0.2-0.2-0.2-0.6,0-0.8s0.6-0.2,0.8,0l2,2l2-2c0.2-0.2,0.6-0.2,0.8,0 s0.2,0.6,0,0.8l-2,2L10.8,10z"/></svg>'
        },
        {
            code: 'styleB',
            icon: 'close',
            default: true,
            style: `
                width: 100%;
                height: 100%;
            `,
            svg: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 16 16" xml:space="preserve" style="width: 100%"><rect x="0" y="0" style="fill:none;" width="16" height="16"/><path d="M8.8,8l4.5-4.5c0.2-0.2,0.2-0.6,0-0.8c-0.2-0.2-0.6-0.2-0.8,0L8,7.2L3.5,2.7c-0.2-0.2-0.6-0.2-0.8,0c-0.2,0.2-0.2,0.6,0,0.8 L7.2,8l-4.5,4.5c-0.2,0.2-0.2,0.6,0,0.8s0.6,0.2,0.8,0L8,8.8l4.5,4.5c0.2,0.2,0.6,0.2,0.8,0s0.2-0.6,0-0.8L8.8,8z"/></svg>'
        }
    ]
};
